// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--9-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--9-oneOf-1-2!../../../node_modules/pintura/pintura.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".image-preview img[data-v-8e97e888] {\n  width: 100%;\n}\n.filepond--root .filepond--drop-label[data-v-8e97e888] {\n  cursor: pointer;\n}\n.filepond--root .filepond--drop-label label[data-v-8e97e888] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
